//
import type { CreateStaffUserRequest } from '@/types/Api/StaffUser'
import type { AxiosCollection, AxiosItem } from '@/types/Components/Response'
import type { StaffUser } from '@/types/Models/StaffUser'
import type { StaffUsersStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import { catchErrors } from '@/services/Helpers'
import AccountProxy from '@/proxies/AccountProxy'

export const useStaffUsersStore = defineStore('staffUsers', {
  state: (): StaffUsersStoreState => ({
    loading: false,
    users: [],
    count: 0,
  }),
  actions: {
    fetchStaffUsers(params: Record<string, string | number>) {
      this.loading = true

      return new AccountProxy({ ...params })
        .all()
        .then((response: AxiosCollection<StaffUser>) => {
          this.users = response.data || []
          this.count = response.count || 0
          return response
        })
        .catch((error) => {
          catchErrors(error)
          this.users = []
          this.count = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    createStaffUser(data: CreateStaffUserRequest) {
      return new AccountProxy()
        .create(data)
        .then((response: AxiosItem<StaffUser>) => {
          return response
        })
        .catch((error) => {
          catchErrors(error)
          return false
        })
    },
    updateStaffUser(payload: {
      id: string
      data: {
        firstName: string
        lastName: string
        email: string
        isInventoryAvailable?: boolean
        password?: string
      }
    }) {
      return new AccountProxy()
        .update(payload.id, payload.data)
        .then((response: AxiosItem<StaffUser>) => response)
        .catch((error) => {
          catchErrors(error)
          return false
        })
    },
    deleteStaffUser(id: string) {
      return new AccountProxy()
        .destroy(id)
        .then((response) => response)
        .catch((error) => {
          catchErrors(error)
          return false
        })
    },
  },
})

export type StaffUsersStore = ReturnType<typeof useStaffUsersStore>
